import * as React from 'react';
import AppProvider from './_context/App';
import Menu from './Components/Menu';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import withStyles, { StyledComponentProps } from 'react-jss';
import stylesheet from './Constants/stylesheet';
import fonts from './Constants/fonts';
import Page from './Components/Page';
import 'minireset.css';
import spacing from './Constants/spacing';
import responsive from './Constants/responsive';

const isTouch = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = (q: string) => {
    return window.matchMedia(q).matches;
  }

  if (('ontouchstart' in window) || (window as any).DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

export type AppProps = {};

const styles = {
  '@global': {
    'html, body': { ...stylesheet.Body },
    '*': {
      margin: 0,
      padding: 0
    },
    'a': {
      ...fonts.ExcelsiorLT,
      color: 'black',
      textDecoration: 'none',
      tapHighlightColor: 'rgba(0,0,0,0)',
      '&:hover': isTouch() ? {} : {
        ...fonts.ExcelsiorLTItalic,
      }
    },
    '#root': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'white',
    },
    '.custom-style-text-indent': {
      [responsive.Mobile]: {
        textIndent: 20
      },
      [responsive.AfterMobile]: {
        textIndent: 40
      },
    },
    'em':{
      ...fonts.ExcelsiorLTItalic,
    },
  },
  app: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // overflow: 'hidden',
    // ...stylesheet.MarginGutter(.5, directions.sides)
  },
  menu: {
    [responsive.Mobile]: {
      flex: `0 0 ${spacing.NavHeight.Mobile}px`,
    },
    [responsive.AfterMobile]: {
      flex: `0 0 ${spacing.NavHeight.Desktop}px`,
    }
  },
  content: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
  }
}
type Props = AppProps &
  StyledComponentProps<keyof typeof styles>;

type State = {
  isMobile: boolean;
};

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this._onResize = this._onResize.bind(this);

    this.state = {
      isMobile: document.body.clientWidth <= 600
    }
  }
  componentDidMount() {
    window.addEventListener('resize', this._onResize);
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    window.addEventListener('resize', this._onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onResize);
  }

  public render() {
    const { classes } = this.props;
    const { isMobile } = this.state;

    return (
      <Router>
        <AppProvider>
          <div className={classes!.app} >
            <Menu isMobile={isMobile} className={classes!.menu} />
            <Switch>
              <Route render={() => <Page isMobile={isMobile} className={classes!.content} />} />
            </Switch>
          </div>
        </AppProvider>
      </Router>
    );
  }

  private _onResize() {
    const viewPortW = document.body.clientWidth;
    const { isMobile } = this.state;
    if (viewPortW <= 600) {
      this.setState({ isMobile: true })
    }

    if (isMobile && viewPortW > 600) {
      this.setState({ isMobile: false })
    }
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.tsx